var render = function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('vue-modal', {
    ref: "vueTermsConditionModal",
    attrs: {
      "name": "termsConditionModal",
      "pivotY": 0.15,
      "width": _vm.widthModal,
      "height": _vm.heightModal,
      "scrollable": true,
      "classes": ['generic-modals', 'v--modal']
    },
    on: {
      "opened": _vm.setInitialData,
      "closed": _vm.closed
    }
  }, [_c('section', {
    staticClass: "ugc-terms-conditions-modal"
  }, [_c('h2', {
    staticClass: "terms-text"
  }, [_vm._v(_vm._s(_vm.translations.termsConditionHeader))]), _c('div', {
    staticClass: "ugc-terms-conditions-modal-wrapper"
  }, [_c('div', {
    staticClass: "ugc-terms-conditions-modal-wrapper-content"
  }, [_c('div', {
    staticClass: "ugc-terms-conditions-modal-wrapper-content-text row"
  }, [_c('strong', [_vm._v(_vm._s(_vm.translations.termsConditionTrades1))]), _c('span', {
    staticClass: "main-text"
  }, [_vm._v(_vm._s(_vm.translations.termsConditionTrades2))])]), _c('div', {
    staticClass: "ugc-terms-conditions-modal-wrapper-content-list row"
  }, [_c('div', {
    staticClass: "small-12 medium-6 large-6 columns"
  }, [_c('ul', {
    staticClass: "ugc-terms-list check"
  }, [_c('li', [_c('strong', [_vm._v(_vm._s(_vm.translations.termsConditionList1))]), _c('span', {
    staticClass: "main-text"
  }, [_vm._v(_vm._s(_vm.translations.termsConditionListDesc1))])]), _c('li', [_c('strong', [_vm._v(_vm._s(_vm.translations.termsConditionList2))]), _c('span', {
    staticClass: "main-text"
  }, [_vm._v(_vm._s(_vm.translations.termsConditionListDesc2))])]), _c('li', [_c('strong', [_vm._v(_vm._s(_vm.translations.termsConditionList3))]), _c('span', {
    staticClass: "main-text"
  }, [_vm._v(_vm._s(_vm.translations.termsConditionListDesc3))])]), _c('li', [_c('span', {
    staticClass: "main-text"
  }, [_vm._v(_vm._s(_vm.translations.termsConditionList4))])])])]), _c('div', {
    staticClass: "small-12 medium-6 large-6 columns"
  }, [_c('ul', {
    staticClass: "ugc-terms-list x"
  }, [_c('li', [_c('strong', [_vm._v(_vm._s(_vm.translations.termsConditionList5))])]), _c('li', [_c('strong', [_vm._v(_vm._s(_vm.translations.termsConditionList6))])]), _c('li', [_c('strong', [_vm._v(_vm._s(_vm.translations.termsConditionList7))])]), _c('li', [_c('strong', [_vm._v(_vm._s(_vm.translations.termsConditionList8))])]), _c('li', [_c('strong', [_vm._v(_vm._s(_vm.translations.termsConditionList9))])]), _c('li', [_c('strong', [_vm._v(_vm._s(_vm.translations.termsConditionList10))])]), _c('li', [_c('strong', [_vm._v(_vm._s(_vm.translations.termsConditionList11))])]), _c('li', [_c('strong', [_vm._v(_vm._s(_vm.translations.termsConditionList12))])]), _c('li', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: _vm.validateText('termsConditionList13'),
      expression: "validateText('termsConditionList13')"
    }]
  }, [_c('strong', [_vm._v(_vm._s(_vm.translations.termsConditionList13))])]), _c('li', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: _vm.validateText('termsConditionList14'),
      expression: "validateText('termsConditionList14')"
    }]
  }, [_c('strong', [_vm._v(_vm._s(_vm.translations.termsConditionList14))])]), _c('li', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: _vm.validateText('termsConditionList15'),
      expression: "validateText('termsConditionList15')"
    }]
  }, [_c('strong', [_vm._v(_vm._s(_vm.translations.termsConditionList15))])]), _c('li', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: _vm.validateText('termsConditionList16'),
      expression: "validateText('termsConditionList16')"
    }]
  }, [_c('strong', [_vm._v(_vm._s(_vm.translations.termsConditionList16))])]), _c('li', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: _vm.validateText('termsConditionList17'),
      expression: "validateText('termsConditionList17')"
    }]
  }, [_c('strong', [_vm._v(_vm._s(_vm.translations.termsConditionList17))])])])])]), _c('div', {
    staticClass: "ugc-terms-conditions-modal-wrapper-content-rights row"
  }, [_c('div', {
    staticClass: "small-12"
  }, [_c('p', {
    staticClass: "vans-reserve"
  }, [_c('strong', [_vm._v(_vm._s(_vm.translations.termsConditionReserve))])]), _c('p', {
    staticClass: "all-customs"
  }, [_vm._v(_vm._s(_vm.translations.termsConditionCustoms))])])])]), _vm.configuration.ugc.enableUGCContactDetails ? _c('contact-form', {
    attrs: {
      "report-field-blur": ""
    },
    on: {
      "validity-update": _vm.updateContactFormValidity,
      "field-blur-event": _vm.resetScreenScrollPosition,
      "contact-details-update": _vm.contactDetailsUpdated
    }
  }) : _vm._e(), _c('div', {
    staticClass: "ugc-terms-conditions-modal-wrapper-cta row"
  }, [_c('div', {
    staticClass: "small-12"
  }, [_c('label', {
    attrs: {
      "for": "add-your-own-check"
    }
  }, [_c('input', {
    staticClass: "add-your-own-check",
    attrs: {
      "type": "checkbox",
      "disabled": !_vm.enableIAgreeCheckbox || !!this.$cookies.get(_vm.sessionKeys.ugcTermsConditionsAccepted)
    },
    domProps: {
      "checked": _vm.hasAcceptedTerms
    },
    on: {
      "change": function change($event) {
        return _vm.setCookie($event);
      }
    }
  }), _c('span', {
    staticClass: "custom radio"
  }, [_vm._v(_vm._s(_vm.translations.termsConditionCheck))])]), _vm.configuration.locale === 'en_us' && _vm.configuration.enableOptInCheckbox ? _c('label', {
    attrs: {
      "for": "newsletter-check"
    }
  }, [_c('input', {
    staticClass: "newsletter-check",
    attrs: {
      "type": "checkbox"
    },
    domProps: {
      "checked": _vm.configuration.forceCheckedOptIn && !this.$cookies.get(_vm.sessionKeys.ugcOptIn) || this.$cookies.get(_vm.sessionKeys.ugcOptIn)
    },
    on: {
      "change": function change($event) {
        return _vm.setOptInCookie($event);
      }
    }
  }), _c('span', {
    staticClass: "custom radio"
  }, [_vm._v(_vm._s(_vm.translations.twoStepsTermsConditionModalTermsOptIn))])]) : _vm._e(), _c('ugc-image-upload', {
    ref: "imageUpload",
    attrs: {
      "disable-button": !_vm.enableChooseImageButton,
      "inputLabel": "termsConditionChooseImage",
      "forceUpload": _vm.hasAcceptedTerms
    },
    on: {
      "click": _vm.setDataLayer
    }
  }), _c('p', {
    staticClass: "moderation-message"
  }, [_vm._v("\n           " + _vm._s(_vm.translations.ugcEPTermsCondReviewExtra) + "\n           "), _c('a', {
    attrs: {
      "target": "blank",
      "href": _vm.translations.ugcEPTermsCondContactLink
    }
  }, [_vm._v(_vm._s(_vm.translations.ugcEPTermsCondReviewContant))])]), _c('p', [_c('a', {
    staticClass: "conditions",
    attrs: {
      "href": _vm.translations.termsConditionLink,
      "target": "_blank"
    }
  }, [_vm._v("\n              " + _vm._s(_vm.translations.termsConditionLinkText) + "\n            ")])])], 1)]), _c('div', {
    attrs: {
      "slot": "top-right"
    },
    slot: "top-right"
  }, [_c('button', {
    staticClass: "close-button",
    attrs: {
      "title": "Close"
    },
    on: {
      "click": function click($event) {
        return _vm.$modal.hide('termsConditionModal');
      }
    }
  }, [_c('span', {
    staticClass: "icon-close"
  })])])], 1)])]);
}
var staticRenderFns = []

export { render, staticRenderFns }